/*
 * @Author: wangzhisong
 * @Date: 2022-08-23 10:01:15
 * @LastEditTime: 2023-01-12 11:17:42
 * @FilePath: \smart-community\src\api\monitorManagement\keyControl.js
 */
import request from "@/utils/request.js";

// 重点人员_重点活动区域
export const countByRegion = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/countByRegion",
    data: data || {},
    method: "post"
  });
};

// 重点人员_活跃趋势
export const dayCount = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/dayCount",
    data: data || {},
    method: "post"
  });
};

// 重点人员_重点人员库统计 重点人员_活跃人数趋势
export const dayPersonNum = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/dayPersonNum",
    data: data || {},
    method: "post"
  });
};
// 重点人员_重点人员库统计 设备告警
export const deviceWarning = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/deviceWarning",
    data: data || {},
    method: "post"
  });
};

// 重点人员_重点活动时段
export const hourCount = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/hourCount",
    data: data || {},
    method: "post"
  });
};

// 重点人员_重点统计
export const impotanceCount = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/impotanceCount",
    data: data || {},
    method: "post"
  });
};

// 重点人员_重点人统计根据区域
export const personNumByRegion = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/personNumByRegion",
    data: data || {},
    method: "post"
  });
};
// 重点人员_重点人统计根据区域 （热力图）
export const oftenOutFromDeviceId = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/oftenOutFromDeviceId",
    data: data || {},
    method: "post"
  });
};

// 重点人员_抓拍总量
export const totalCount = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/totalCount",
    data: data || {},
    method: "post"
  });
};

// 重点人员_抓拍人员数
export const totalPersonNum = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/totalPersonNum",
    data: data || {},
    method: "post"
  });
};

// 重点人员_抓拍人员数
export const keyFaceList = data => {
  return request({
    url: "/apiData/hz-data-community/face/list",
    data: data || {},
    method: "post"
  });
};

// 落脚点分析汇中获取人脸ID
export const searchFaceID = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/person-analysis/search",
    data: data || {},
    method: "post"
  });
};

// 重点人员_频繁出没
export const oftenOut = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/oftenOut",
    data: data || {},
    method: "post"
  });
};

// 重点人员_疑似离开
export const suspectedLeave = data => {
  return request({
    url: "/apiData/hz-data-community/styp/follow/count/face/suspectedLeave",
    data: data || {},
    method: "post"
  });
};
// 重点人员_人脸检索详情
export const outlistDetails = data => {
  return request({
    url: "/api/hz-data-community/face/search/detail/list",
    params: data || {}
  });
};

// 重点人员_人脸检索设备抓拍（热力图）
// export const oftenOutFromDeviceId = data => {
//   return request({
//     url: "/api/hz-data-community/face/search/oftenOutFromDeviceId",
//     params: data || {}
//   });
// };